/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Device_Code_ConfirmInputs */



/**
* | output |
* | --- |
* | "Make sure this matches the code shown in your app" |
*
* @param {Auth_Device_Code_ConfirmInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const auth_device_code_confirm = /** @type {((inputs?: Auth_Device_Code_ConfirmInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Device_Code_ConfirmInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Stelle sicher, dass dieser Code mit dem in deiner App übereinstimmt")
	return /** @type {LocalizedString} */ ("Make sure this matches the code shown in your app")
});